import React from "react"

export default function Blog036() {
  return (
    <section>
    <article>
    <h2>36. 01-10-2023</h2>
          <h3>Python</h3>
          <p>
          <strong>I started learning Python!</strong>
          <br /><br />
          I work as a self-taught software developer at In The Zone, and I'm constantly looking for fresh, interesting ways to grow my abilities. I've recently been concentrating on learning Python, and I've been using a variety of tools to aid me in my endeavor.
          <br /><br />
          I recorded another vlog a few days ago, which marked the 6-month anniversary of my journey to learn Python. Over the past 6 months, I've been using freecodecamp, chatGPT, YouTube videos, and Google to help me learn the language. I've also been experimenting with different frameworks and libraries, such as tkinter and pyglet.
          <br /><br />
In the past, I've also used turtle for some simple projects, but I've found that pygame doesn't seem to be working for me. The website is even down, which is unfortunate, but it led me to discover other frameworks that work in a similar way. I've decided to focus on using pyglet for now.
<br /><br />
One of the things I've found most challenging about learning Python is figuring out the best way to approach a problem. There are so many different libraries and frameworks available, and it can be difficult to know which one to use. But by experimenting with different options, I've been able to get a better sense of what works best for me.
<br /><br />
As I continue to learn and improve my skills in Python, I plan on recording tutorials on other languages and frameworks, such as JavaScript and React.js. I think that by sharing my experience and knowledge, I can help others who are just getting started on their own learning journey.
<br /><br />
Overall, it's been a challenging and exciting journey, but I'm excited to continue learning and growing as a software developer. I believe that with a little bit of perseverance, anyone can learn to code and become a great developer. If you're just getting started, don't be afraid to experiment and try new things - you never know what you might discover!

<br /><br />
<br /><br />
Thanks for reading,<br />
Eric Polley
<br />



         
          </p>
          
          </article>

        <h4>Links</h4>
        <br />
        <ul>
        <li>
            <a
              href="https://github.com/ericpolley/PythonTests"
              title="Python!"
              target="_blank"
              rel="noopener noreferrer" 
            >
              <strong><p>Python Tests</p></strong></
            a>
          </li>
        
          <li>
            <a
              href="http://ericpolley.com"
              title="Check out my Portfolio!"
              target="_blank"
              rel="noopener noreferrer" 
            >
              <strong><p>Eric Polley's Website</p></strong></a
            >
          </li>
        </ul>
        </ section >
  )
}
